import { render, staticRenderFns } from "./CommunicationRecordsDialog.vue?vue&type=template&id=49f176f6&scoped=true"
import script from "./CommunicationRecordsDialog.vue?vue&type=script&lang=js"
export * from "./CommunicationRecordsDialog.vue?vue&type=script&lang=js"
import style0 from "./CommunicationRecordsDialog.vue?vue&type=style&index=0&id=49f176f6&prod&lang=less&scoped=true"
import style1 from "./CommunicationRecordsDialog.vue?vue&type=style&index=1&id=49f176f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f176f6",
  null
  
)

export default component.exports